<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-card v-for="(item, i) in computedValue" :key="i" flat>
        <div class="d-flex align-center">
          <v-btn :disabled="i <= 0" class="me-2" icon small @click="moveUp(i)">
            <v-icon>mdi-chevron-up</v-icon>
          </v-btn>
          <v-btn
            :disabled="i + 1 >= value.length"
            class="me-2"
            icon
            small
            @click="moveDown(i)"
          >
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
          {{ $t("extraSubProducts.feature") }}
          <v-icon v-if="!!item.icon" class="mx-2">{{ item.icon }}</v-icon>
          <span v-else class="mx-2">{{ i + 1 }}</span>
          <v-spacer />
          <v-btn
            v-if="value.length > 1"
            class="ms-1"
            icon
            @click="removeSubProduct(i)"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </div>

        <v-row no-gutters>
          <v-col class="pa-md-3 pe-md-1" cols="12" md="6">
            <v-text-field
              v-model="computedValue[i].name"
              class="rounded-md"
              clear-icon="mdi-close-circle-outline"
              clearable
              dense
              :label="$t('extraSubProducts.name_label')"
              :placeholder="$t('extraSubProducts.name_placeholder')"
              outlined
            />
          </v-col>

          <v-col class="pa-md-3 pe-md-1" cols="12" md="6">
            <v-text-field
              v-model="computedValue[i].price"
              class="rounded-md"
              clear-icon="mdi-close-circle-outline"
              clearable
              dense
              :hint="$t('extraSubProducts.price_hint')"
              :label="$t('extraSubProducts.price_label')"
              :placeholder="$t('extraSubProducts.price_placeholder')"
              outlined
            />
          </v-col>
        </v-row>
      </v-card>
    </v-col>

    <v-col class="pa-md-3" cols="12">
      <v-btn
        block
        class="rounded-lg"
        color="success"
        outlined
        @click="addSubProduct"
      >
        {{ $t("extraSubProducts.add_subproduct") }}
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import IconPicker from "@/view/components/IconPicker.vue";

export default {
  name: "extraSubProducts",
  components: { IconPicker },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.value.length
          ? this.value
          : [{ name: "", image: "", price: "", max: 0, stock: true }];
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    addSubProduct() {
      this.computedValue = [
        ...this.computedValue,
        {
          name: "",
          image: "",
          price: "",
          max: 0,
          stock: true,
        },
      ];
    },
    removeSubProduct(index) {
      if (this.computedValue.length <= 1) {
        this.computedValue = [
          {
            name: "",
            image: "",
            price: "",
            max: 0,
            stock: true,
          },
        ];
      } else {
        this.computedValue = this.computedValue.filter((_, i) => i !== index);
      }
    },
    moveUp(index) {
      if (index <= 0) return;
      const arr = [...this.computedValue];
      [arr[index], arr[index - 1]] = [arr[index - 1], arr[index]];
      this.computedValue = arr;
    },
    moveDown(index) {
      if (index + 1 >= this.computedValue.length) return;
      const arr = [...this.computedValue];
      [arr[index], arr[index + 1]] = [arr[index + 1], arr[index]];
      this.computedValue = arr;
    },
  },
};
</script>

<style scoped>
.v-expansion-panel {
  border-radius: 15px !important;
  box-shadow: 8px 5px 10px #f49d1a;
}

.v-expansion-panel
  >>> .v-expansion-panel-header.v-expansion-panel-header--active {
  background-color: #001554 !important;
  border-radius: 15px !important;
  color: whitesmoke !important;
}

.v-expansion-panel
  >>> .v-expansion-panel-header.v-expansion-panel-header--active
  .v-icon {
  color: whitesmoke !important;
}
</style>
